import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import zhCN from './locales/zh-CN.json'
import zhTW from './locales/zh-TW.json'

const savedLanguage = localStorage.getItem('i18nextLng') || 'zh-CN';

i18n
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    resources: {
      en: { translation: en },
      'zh-CN': { translation: zhCN },
      'zh-TW': { translation: zhTW },
    },
    lng: savedLanguage, // Default language
    fallbackLng: 'zh-CN', // Fallback language
    interpolation: {
      escapeValue: false, // React already escapes content
    },
  });

export default i18n;